'use client';

import clsx from 'clsx';
import { ReactNode } from 'react';
import styles from './EpSelectItem.module.scss';
import { EpIcon } from '../EpIcon';
import { EpButton } from '../EpButton';
import { EpEventSentinelModal } from '../HookFormComponents/components/EpSentinelEventModal';
import { t2, ITranslations } from '../../hooks/useTranslation';

interface IEpSelectItemProps {
  children?: ReactNode;
  description: string;
  id: number;
  selectedItem: number | undefined;
  setSelectedItem: () => void;
  title: string;
  translations: unknown;
}

export const EpSelectItem = ({
  children,
  description,
  id,
  selectedItem,
  setSelectedItem,
  translations,
  title,
}: IEpSelectItemProps) => {
  const t = (term: string) => t2(translations as [ITranslations], term);
  const sentinelEventId = 8;

  return (
    <div className={styles['container']}>
      <div>
        <div className={styles['container__card']}>
          <div className={styles['head']}>
            <div className={styles['head__title']}>
              <p className={styles['typograph__title']}>{title}</p>

              {id === sentinelEventId && (
                <EpButton
                  buttonId={'step3-sentinel-event-btn'}
                  buttonType={'link-primary'}
                  buttonLeftIconName={'SolidQuestionCircle'}
                  buttonDataBsTarget="#event-sentinel-modal"
                  buttonDataBsToggle="modal"
                  buttonOnClickFunc={() => console.log()}
                  buttonSize="sm"
                />
              )}
            </div>

            <button
              type="button"
              className={styles['btn']}
              onClick={setSelectedItem}
            >
              {selectedItem ? (
                <EpIcon iconName="SolidPencilAlt" />
              ) : (
                <EpIcon iconName="SolidCheck" />
              )}
              <span>{selectedItem ? t('Change') : t('Select')}</span>
            </button>
          </div>
          <p className={styles['typograph__txt']}>{description}</p>
        </div>
      </div>

      {selectedItem && (
        <div className={clsx(selectedItem && styles['content'])}>
          {children}
        </div>
      )}

      <EpEventSentinelModal translations={translations} />
    </div>
  );
};
